import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/annual-return/components/AnnualReturnSkeleton.tsx");
